import '@styles/ProductCard/style.css'
import cn from 'classnames'
import kebabCase from 'lodash/kebabCase'
import React from 'react'
import { ProductCardSizes } from '@constants'

export interface IEnhancedProductCard {
  isActive?: boolean
  size?: ProductCardSizes
  cardCss?: string
}

const EnhancedProductCardWrapper: React.FC<IEnhancedProductCard> = (
  props
): JSX.Element => {
  const { isActive = true, children, size = ProductCardSizes.Medium, cardCss } = props

  return (
    <div
      className={cn(
        'product-card',
        {
          'product-card-inactive': !isActive
        },
        size ? `enhanced-product-card-${kebabCase(size)}` : '',
        cardCss
      )}
    >
      {children}
    </div>
  )
}

export default EnhancedProductCardWrapper
